import store from '@/store'
import publicJs from '@/utils/js/publicJs'
/** 初始化配置 */
function init (){
  initHandler("mac", getMac())
  //设备登录
  store.dispatch('deviceLogin')
}
/** 获取mac地址 */
function getMac(){
  return publicJs.guid()
}

/** 初始化处理器 */
function initHandler(key, val){
  console.log("mac：", localStorage.getItem(key))
  if(!localStorage.getItem(key)){
    localStorage.setItem(key, val)
  }
}


export default {
  init
}